import styled from "styled-components";

export const RowForInput = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 43px;

    @media (max-width: 500px){
        display: block;
        margin-bottom: 0px;
    }
`;

export const RowForTwoInput = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;

export const InputContainer = styled.div`
    width: 47%;

    @media (max-width: 500px){
        width: 100%;
        margin-bottom: 30px;
    }
`;

export const TitleField = styled.h2`
    font: normal normal normal 16px Circular Std Book;
    margin-bottom: 24px;
    color: #454546;
`;

export const RowForButton = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 35px;
`;

export const ButtonContainer = styled.div`
    width: 35%;

    button {
        padding: 8px;
    }

    @media (max-width: 500px){
        width: 100%;
    }
`;